<template>
     <el-menu background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" :default-active="$store.state.teb.default_active"
            class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" :collapse="isCollapse">
            <h1 style="font-size: 150%;">Nabway</h1>
            <el-menu-item  @click="goHome" index="0">
                <i class="el-icon-s-home"></i>
                <span slot="title">home</span>
            </el-menu-item>
            <!-- 带下拉的导航栏 -->
            <el-submenu v-if="$store.state.teb.white808S!==null && $store.state.teb.white808S !==[]&&this.$store.state.teb.white808S.length>0" index="1">
                <template slot="title">
                    <i class="el-icon-monitor"></i>
                    <span slot="title">808_H</span>
                </template>
                <el-menu-item-group>
                    <el-menu-item   @click="clickMenu(1,item)" v-for="item in $store.state.teb.white808S" :index="item.id" :key="'white808S-' + item.id"   activite>{{item.machine}}</el-menu-item>
                </el-menu-item-group>
            </el-submenu>
            <el-submenu v-if="$store.state.teb.black808S!==null && $store.state.teb.black808S !==[]&&this.$store.state.teb.black808S.length>0" index="2">
                <template slot="title">
                    <i class="el-icon-monitor"></i> 
                    <span slot="title">808_B</span>
                </template>
                <el-menu-item-group>
                    <el-menu-item @click="clickMenu(2,item)" v-for="item in $store.state.teb.black808S" :index="item.id" :key="'black808s_'+item.id"  activite>{{item.machine}}</el-menu-item>
                </el-menu-item-group>
            </el-submenu>
            <el-submenu v-if="$store.state.teb.cl4S!==null && $store.state.teb.cl4S !==[] && this.$store.state.teb.cl4S.length>0" index="3">
                <template slot="title">
                    <i class="el-icon-monitor"></i>
                    <span slot="title">Cl4</span>
                </template>
                <el-menu-item-group>
                    <el-menu-item @click="clickMenu(3,item)" v-for="item in $store.state.teb.cl4S" :key="'cl4s_'+item.id" :index="item.id"  activite>{{item.machine}}</el-menu-item>
                </el-menu-item-group>
            </el-submenu> 
            <el-submenu v-if="$store.state.teb.cl4FaceS !==null && $store.state.teb.cl4FaceS !=[] && this.$store.state.teb.cl4FaceS.length>0" index ="4">
                <template slot="title">
                    <i class="el-icon-monitor"></i>
                    <span slot="title">cl4Face</span>                  
                </template>
                <el-menu-item-group>
                    <el-menu-item @click="clickMenu(4,item)" v-for="item in $store.state.teb.cl4FaceS" :key="'cl4Faces_'+item.id" :index="item.id" activite>{{item.machine}}</el-menu-item>
                </el-menu-item-group>
            </el-submenu>
            <el-menu-item index="logout" @click="logout">
                    <i class="el-icon-switch-button"></i>
                    <span slot="title">Quit</span>
            </el-menu-item>
            <el-menu-item index="logout" @click="swichToHTML"  style="position: fixed; bottom: 10px;">
                    <i class="el-icon-share"></i>
                    <span slot="title">software download</span>
            </el-menu-item>
           
           
        </el-menu>
</template>
<script>
import { Image } from 'element-ui';

export default {
    data() {
        return {
            id: 1,
            mode: 'white'
        };
    },
    methods: {
        swichToHTML(){
            localStorage.removeItem("userData");
            window.location.href = './index.html';
        },
        logout(){
             // 处理退出命令
             localStorage.removeItem("userData");
             this.$router.push('/login');
        },
        handleOpen(key, keyPath) {
        },
        handleClose(key, keyPath) {
        },
        goHome() {
            if (this.$route.path !== '/home' && this.$route.path !== '/') {
                this.$store.state.teb.default_active = '0';
                this.$router.push('/home');
            }
        },
        clickMenu(item, machine) {
            this.$store.state.teb.machineID = machine.machine;
            console.log("machine",machine)
            if (item === 1) {
                if (this.$route.path !== '/white808') {
                    this.$store.state.teb.default_active = machine.id;
                    this.$router.push('/white808');
                }
            }
            else if (item === 2) {
                if (this.$route.path !== '/black808') {
                    this.$store.state.teb.default_active = machine.id;
                    this.$router.push('/black808');
                }
            }
            else if (item === 3) {
                if (this.$route.path !== '/cl4') {
                    this.$store.state.teb.default_active = machine.id;
                    this.$router.push('/cl4');
                }
            }
            else if (item === 4){
                if(this.$route.path !=='/cl4Face'){
                    console.log("cl4Face =")
                    this.$store.state.teb.default_active = machine.id;
                    this.$router.push('/cl4Face');
                }
            }
        },
        fetchWhite808Data() {
            this.$store.dispatch('getMachineID', { mode: 'white808', userID: JSON.parse(localStorage.getItem("userData")).userID });
        },
        fetchBlack808Data() {
            this.$store.dispatch('getMachineID', { mode: 'black808', userID: JSON.parse(localStorage.getItem("userData")).userID });
        },
        fetchCl4Data() {
            this.$store.dispatch('getMachineID', { mode: 'cl4', userID: JSON.parse(localStorage.getItem("userData")).userID });
        },
        fetchCl4FaceData(){
            this.$store.dispatch("getMachineID", { mode :'cl4Face',userID: JSON.parse(localStorage.getItem("userData")).userID})
        }
    },
    computed: {
        isCollapse() {
            return this.$store.state.teb.isCollapse;
        },
    },
    created() {
        this.fetchBlack808Data();
        this.fetchWhite808Data();
        this.fetchCl4Data();
        this.fetchCl4FaceData();
    },
    components: { Image }
}
</script>
<style lang="less" scoped>
    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 200px;
        min-height: 100%;
        padding: 0;
        margin: 0;
    }
    .el-menu {
    height: 100vh;
    border-right: none ;
    padding: 0;
        h1 {
            color: #fff;
            text-align: center;
            line-height: 30px;
            font-size: 16px;
            font-weight: 400;
        }
    }
    .icon-user {
      background-image: url('../images/icon.png');
    }
</style>